import { render, staticRenderFns } from "./SwitchOrdersDetailsDialog.vue?vue&type=template&id=f2643922&scoped=true"
import script from "./SwitchOrdersDetailsDialog.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersDetailsDialog.vue?vue&type=style&index=0&id=f2643922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2643922",
  null
  
)

export default component.exports